import { filterDel } from '../utils'
import { GROUP_MANAGE } from './constants'
import { getAllGroupApi,updateGroupApi,getGroupCustomersApi,addCustomersApi,getAppRouterListApi,getAppTreeApi, updateMenuItemsApi,getGroupAppListApi,getSelectItemApi } from './service'
const model = {
    name: GROUP_MANAGE,
    namespaced: true,
    state: {
        appList: [],
        groups:[],
        groupDetail: {},
        appDetailList:[],
        appListHash:{},
        selectedJurisdictionHash: {},
        tree: [],
        loading: {
            getAllGroupLoading: false,
            updateGroupLoading: false,
            getGroupCustomerLoading: false,
            addCustomerLoading: false,
            getAppListLoading: false,
            getAppTreeLoading: false,
            updateMenuItemsLoading: false,
            getSelectedJurisdictionListLoading: false
        }
    },
    mutations: {
        setStateLevel0 (state,{ key, value}) {
            state[key] = value
        },
        setLoading (state,{ key,value }) {
            state.loading[key] = value
        },
        detialEditDestryed (state) {
            state.tree = []
            state.groupDetail = {}
            state.appList = []
            state.appDetailList = []
            state.selectedJurisdictionHash = {}
            state.appListHash = {}
        }
    },
    actions: {
        // 获取列表
        async getAllGroup ({ commit }) {
            commit('setLoading',{ key:'getAllGroupLoading', value:true })
           const { groups } = await getAllGroupApi({},() => {
            commit('setLoading',{ key:'getAllGroupLoading', value:false })
           })
           commit('setStateLevel0',{key:'groups',value:groups})
        },
        // 更新
        async updateGroup ({ commit,dispatch },{params,callBack}) {
            const {_isDel=false,...other} = params
            commit('setLoading',{ key:'updateGroupLoading', value:true })
            await updateGroupApi(other,() => {
                commit('setLoading',{ key:'updateGroupLoading', value:false })
            })
            if(callBack) {
                callBack(_isDel,params.del)
            }
                dispatch({type:'getAllGroup'})
        }, 
        // 获取app列表
        async getGroupAppList ({ commit },params) {
            commit('setLoading',{ key:'getAppListLoading', value:true })
            const { apps } = await getGroupAppListApi(params,() => { // 获取app列表
                commit('setLoading',{ key:'getAppListLoading', value:false })
            }) 
            commit('setStateLevel0',{ key:'appDetailList', value:apps || [] })
            commit('setStateLevel0',{ key:'appListHash', value:(apps || []).reduce((total,item) => {
                total[item.id] = true
                return total
            },{}) })
        },
        // 获取群内成员
        async getGroupCustomers ({ commit },params) {
                commit('setLoading',{ key:'getGroupCustomerLoading', value:true })
                const { group } = await getGroupCustomersApi(params,() => { // 获取人员列表
                        commit('setLoading',{ key:'getGroupCustomerLoading', value:false })
                     })
                commit('setStateLevel0',{ key:'groupDetail', value:group })
        },
        // 增删群组成员
        async addCustomers ({ commit },{params,callBack}) {
            commit('setLoading',{ key:'addCustomerLoading', value:true })
           const{ group } = await addCustomersApi(params,() => {
                commit('setLoading',{ key:'addCustomerLoading', value:false })
            })
            if(callBack) {
                callBack(params.type)
            }
            commit('setStateLevel0',{ key:'groupDetail', value:group })
        },
        // 获取app列表
        async getAppRouterList ({ commit,state },params) {
            if(state.appList.length>0) {
                return
            }
            commit('setLoading',{ key:'getAppListLoading', value:true })
           const { list } = await getAppRouterListApi(params,() => {
                commit('setLoading',{ key:'getAppListLoading', value:false })
            })
           commit('setStateLevel0',{ key:'appList', value:list })
        },
        // 获取app权限树
        async getAppTree ({ commit },params) {
            commit('setStateLevel0',{ key:'tree', value: []})
            commit('setLoading',{ key:'getAppTreeLoading', value:true })
            const { app } = await getAppTreeApi(params,{final:() => {
              commit('setLoading',{ key:'getAppTreeLoading', value:false })
             }})
             commit('setStateLevel0',{ key:'tree', value:filterDel([ app ])})
        },
        // 更新权限条目
        async updateMenuItems ({ commit },{params,callBack}) {
            commit('setLoading',{ key:'updateMenuItemsLoading', value:true })
            await updateMenuItemsApi(params,() => {
                commit('setLoading',{ key:'updateMenuItemsLoading', value:false })
            })
            if(callBack) {
                callBack(params.add_item_ids)
            }
        },
        // 获取已选择权限getSelectItemApi
        async getSelectItem ({ commit },params) {
            commit('setStateLevel0',{ key:'selectedJurisdictionHash', value: {}})
            commit('setStateLevel0',{ key:'tree', value: []})
            commit('setLoading',{ key:'getAppTreeLoading', value:true })
          const [{ items },{ app }] = await Promise.all([
              getSelectItemApi(params,{ fail:() => {
                commit('setLoading',{ key:'getAppTreeLoading', value:false })
              }}),
              getAppTreeApi({id:params.route_app_id},{ fail: () => {
                commit('setLoading',{ key:'getAppTreeLoading', value:false })
               }})
          ])
          commit('setLoading',{ key:'getAppTreeLoading', value:false })
            // Array => Hash
            const selectedObj = items.reduce((total,item) => {
                total[item.id] = item
                return total
            },{})
            // 为tree的每个条目添加checkout状态
            app.items&&app.items.length>0&&app.items.reduce(function setCheckout (total,item) {
                if(selectedObj[item.id]) {
                    item.checkout = true
                    if(item.items&&item.items.length>0) {
                        item.items.reduce(setCheckout,[])
                    }
                }
                return total
            },[]);
            commit('setStateLevel0',{ key:'selectedJurisdictionHash', value: selectedObj})
            commit('setStateLevel0',{ key:'tree', value:filterDel([ app ])})
        }
    }
  };
  
  export default model;
  